import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ThemeMode = 'LIGHT' | 'DARK' | 'SYSTEM';
type ColorScheme =
  | 'OCEAN_BLUE'
  | 'FOREST_GREEN'
  | 'ROYAL_PURPLE'
  | 'SUNSET_ORANGE'
  | 'MIDNIGHT'
  | 'CORPORATE';

interface ThemeState {
  mode: ThemeMode;
  colorScheme: ColorScheme;
  sidebarCollapsed: boolean;
  setMode: (mode: ThemeMode) => void;
  setColorScheme: (scheme: ColorScheme) => void;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

/**
 * Theme store for managing UI appearance preferences
 * Persisted to localStorage for consistent user experience
 */
export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      mode: 'LIGHT',
      colorScheme: 'OCEAN_BLUE',
      sidebarCollapsed: false,

      setMode: (mode) => set({ mode }),
      setColorScheme: (colorScheme) => set({ colorScheme }),
      toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
    }),
    {
      name: 'gi-theme-storage',
    }
  )
);
